import React from 'react';
import './App.css';
import DeliveryCalculator from './components/DeliveryCalculator';

function App() {
  return (
    <div className="App min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-[#f5f5f7] to-white">
      <DeliveryCalculator />
      <footer className="mt-8 mb-8 text-center text-[#86868b] text-sm">
        <p>&#169;2025 Crave Cookies Franchising, LLC - Delivery Platform Economics Calculator</p>
      </footer>
    </div>
  );
}

export default App;
